import { corePuleApplicationsIdMapReducers } from './_idMap';
import { DataSecurityApplication } from '@types';
import { getCoreDataSecurityApplicationsSlice } from './get';
import { hideCoreDataSecurityApplicationsSlice } from './hide';
import { PaginatedResource } from '@sonar-software/sonar-ts-types';
import { removeCoreDataSecurityApplicationSyncSlice } from './remove';
import { unhideCoreDataSecurityApplicationsSlice } from './unhide';
import { updateCoreDataSecurityApplicationSyncSlice } from './update';

import { AsyncState, combineAllWatchers, joinReducers } from '@sonar-software/xuder';
import { combineReducers, Reducer } from 'redux';
import { coreDataSecurityApplicationsAllReducers, coreDataSecurityApplicationsAllWatchers } from './all';
import { coreDataSecurityApplicationsBulkReducers, coreDataSecurityApplicationsBulkWatchers } from './bulk';
import { coreDataSecurityApplicationsByIdReducers, coreDataSecurityApplicationsByIdWatchers } from './_id';
import { coreDataSecurityApplicationsObjectsReducers, coreDataSecurityApplicationsObjectsWatchers } from './objects';

export const coreDataSecurityApplicationsReducers = combineReducers({
	all: coreDataSecurityApplicationsAllReducers,
	bulk: coreDataSecurityApplicationsBulkReducers,
	byId: coreDataSecurityApplicationsByIdReducers,
	byIdMap: corePuleApplicationsIdMapReducers,
	get: joinReducers(
		[
			getCoreDataSecurityApplicationsSlice.asyncReducers,
			removeCoreDataSecurityApplicationSyncSlice.syncReducer,
			updateCoreDataSecurityApplicationSyncSlice.syncReducer
		],
		getCoreDataSecurityApplicationsSlice.asyncState
	) as Reducer<AsyncState<PaginatedResource<DataSecurityApplication>>>,
	hide: hideCoreDataSecurityApplicationsSlice.asyncReducers,
	objects: coreDataSecurityApplicationsObjectsReducers,
	unhide: unhideCoreDataSecurityApplicationsSlice.asyncReducers
});

export const coreDataSecurityApplicationsWatchers = combineAllWatchers([
	coreDataSecurityApplicationsAllWatchers,
	coreDataSecurityApplicationsBulkWatchers,
	coreDataSecurityApplicationsByIdWatchers,
	coreDataSecurityApplicationsObjectsWatchers,
	getCoreDataSecurityApplicationsSlice.asyncWatchers,
	hideCoreDataSecurityApplicationsSlice.asyncWatchers,
	unhideCoreDataSecurityApplicationsSlice.asyncWatchers
]);
